import React, { useCallback } from 'react';

import styled from 'styled-components';

import ColorWheel from '~/shared/components/ColorWheel/ColorWheel.js';

import { CUSTOM_COLOR_FILTER } from '../../constants.js';
import useSelectedFacetsToApply from '../../hooks/useSelectedFacetsToApply';

const MobileGridColorWheelFilterWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

function MobileGridColorWheelFilter() {
  const { setSelectedFacetsToApply } = useSelectedFacetsToApply();

  const setSelectedColor = useCallback(
    async (selectedColor) => {
      const colorValue = Object.values(selectedColor).join(',');

      setSelectedFacetsToApply((prev) => ({
        ...prev,
        [CUSTOM_COLOR_FILTER.name]: [colorValue],
      }));
    },
    [setSelectedFacetsToApply]
  );

  return (
    <MobileGridColorWheelFilterWrapper>
      <ColorWheel
        lightness={50}
        onColorSelect={(rgb) => setSelectedColor(rgb)}
      />
    </MobileGridColorWheelFilterWrapper>
  );
}

export default MobileGridColorWheelFilter;
